import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { deepCompare } from "@website/utils/deep-compare";
import { AnimatedTelesales } from "@website/widget/telesales/animatedTelesale";
import { useTelesales } from "@website/widget/telesales/hooks";
import { TelesalesForm } from "@website/widget/telesales/telesales-form";
import { TelesalesPropertiesType } from "@website/widget/telesales/types";
import { useRouter } from "next/router";
import { memo } from "react";

const Component = ({
  isPadding = false,
  requestData,
  storageKey,
  reasons,
  onButtonClick,
  onSuccess,
  description,
  className
}: TelesalesPropertiesType) => {
  const { isOpenModal, setIsOpenModal, handleOpenModal, isSubmitBefore } =
    useTelesales(storageKey, requestData.app);
  const router = useRouter();
  return (
    <>
      <div
        className={`${
          ["villa", "hotel-domestic"].includes(
            process.env.NEXT_PUBLIC_APP_NAME ?? ""
          )
            ? "hidden md:block"
            : "block"
        }`}
      >
        <Button
          StartIcon={
            <MaterialIcon
              className="absolute right-3 top-2 text-2xl"
              name="phone_enabled"
            />
          }
          children="رزرو تلفنی"
          className={`shadow-8 !fixed bottom-6 ${
            isPadding ? "max-lg:bottom-24 max-md:bottom-36" : ""
          } right-6 z-[12] gap-3 ${className ?? ""}`}
          color="secondary"
          onClick={() => {
            onButtonClick?.();
            handleOpenModal();
          }}
          size="large"
          variant="round"
        />
      </div>
      <div
        className={`${
          ["villa", "hotel-domestic"].includes(
            process.env.NEXT_PUBLIC_APP_NAME ?? ""
          ) && !router?.pathname?.includes("map")
            ? "block md:hidden"
            : "hidden"
        }`}
      >
        <AnimatedTelesales
          onClick={() => {
            onButtonClick?.();
            handleOpenModal();
          }}
        />
      </div>
      <Modal
        className="flex gap-6"
        dialogClassName="lg:max-w-[448px]"
        headerStyle="text-headline-6 m-0"
        mobileHeight="auto"
        onClose={() => setIsOpenModal(false)}
        open={isOpenModal}
        showCloseButton
        title="ثبت درخواست رزرو تلفنی"
      >
        <TelesalesForm
          description={description}
          isSubmitBefore={isSubmitBefore}
          onClose={() => setIsOpenModal(false)}
          onSuccess={onSuccess}
          reasons={reasons}
          requestData={requestData}
          storageKey={storageKey}
        />
      </Modal>
    </>
  );
};
export const Telesales = memo(Component, deepCompare);
